module.exports = __webpack_public_path__ + "static/media/hospital.e1d28a5c.svg";